import React from "react";
import { Text, View, StyleSheet } from "react-native";
import Svg, { Path } from "react-native-svg";

export default function TodayIcon(props) {
  return (
    <View style={styles.container}>
      <Svg
        width={props.width !== undefined ? props.width : 28}
        height={props.height !== undefined ? props.height : 23}
        viewBox="0 0 28 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M20.4832 2.87504V3.12504H20.7332H21.833C22.9382 3.12504 23.7827 3.90684 23.7827 4.79171V18.2084C23.7827 19.0932 22.9382 19.875 21.833 19.875H6.43527C5.90792 19.875 5.40793 19.6922 5.0441 19.3752C4.68139 19.0591 4.48562 18.6385 4.4856 18.2085C4.4856 18.2084 4.4856 18.2084 4.4856 18.2084L4.49659 4.79191V4.79171C4.49659 3.90457 5.32166 3.12504 6.43527 3.12504H7.53511H7.78511V2.87504V1.20837H9.48478V2.87504V3.12504H9.73478H18.5335H18.7835V2.87504V1.20837H20.4832V2.87504ZM21.833 18.4584H22.083V18.2084V7.66671V7.41671H21.833H6.43527H6.18527V7.66671V18.2084V18.4584H6.43527H21.833ZM8.88494 9.83337H13.8841V14.125H8.88494V9.83337Z"
          fill={props.fill !== undefined ? props.fill : "#545454"}
          fillOpacity="0.74"
          stroke="white"
          strokeWidth="0.5"
        />
      </Svg>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});
